import m from "../../geodata/es2015/algeriaLow";
window.am4geodata_algeriaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/algeriaLow.js
// module id = null
// module chunks = 